




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Facility } from '@/models/facility';

@Component
export default class FacilityItem extends Vue {
  @Prop({ type: Object, required: true }) item!: Facility;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }
}
